import applogger from '@applogger'

function install(Vue, options) {
  const reduce = vm => (acc, cur) => cur ? (typeof cur === 'function' ? cur.call(vm, acc) : cur) : acc
  const getCb = (vm, tag) => options[tag] && vm[options[tag]] ? vm[options[tag]] : false
  const getValue = (vm, choices) => choices.reduce(reduce(vm), '')
  const setData = (vm) => {
    vm.hm.currentData.title = getTitle(vm)
    vm.hm.currentData.titleTemplate = getTitleTemplate(vm)
    vm.hm.currentData.meta = getMetaTags(vm)
    vm.hm.currentData.link = getLinks(vm)

    if (typeof window !== 'undefined') {
      const { set } = vm.$meta().addApp('ssr')
      set({
        title: getTitleTemplate(vm).replace(/%s/, getTitle(vm)),
        meta: getMetaTags(vm),
        link: getLinks(vm)
      })
    }
  }

  const resetHeadData = (vm) => {
    vm.hm.currentPath = false
    vm.hm.currentData = {
      title: '',
      titleTemplate: '',
      meta: [],
      link: []
    }
  }

  function getMeta(vm, asPromise = false) {
    const { headData } = vm.$options
    let ret = {}
    if (headData || vm.$headRouteComponent) {
      if (vm.$route && (!vm.currentPath || vm.currentPath !== vm.$route.path)) {
        vm.currentPath = vm.$route.path
        const cb = getCb(vm, 'fetchData')
        if (typeof cb === 'function') {
          const res = cb.call(vm, vm.$route.path)
            .then(_ => {
              setData(vm)
            })
            .catch(err => {
              applogger.error(`Could not load SEO metadata for ${vm.$route.path} - ${err}`)
            })

          if (asPromise) {
            return res
          }
        }
      }

      if (typeof window === 'undefined') {
        ret = vm.hm.currentData
      }
    }

    return asPromise ? Promise.resolve(ret) : ret
  }

  function getMetaTags(vm) {
    const values = getCb(vm, 'metaTagsCallback')
    return getValue(vm, [values])
  }

  function getLinks(vm) {
    const values = getCb(vm, 'linksCallback')
    return getValue(vm, [values])
  }

  function getTitle(vm) {
    const { headTitle } = vm.$options
    const defaultTitle = vm.$store.getters.getSiteSetting('title')
    const values = ['', defaultTitle, vm.$route.name, headTitle, getCb(vm, 'titleCallback')]
    return getValue(vm, values)
  }

  function getTitleTemplate(vm) {
    const defaultTitle = vm.$store.getters.getSiteSetting('title')
    const { headTitleTemplate } = vm.$options
    return getValue(vm, [defaultTitle ? '%s - ' + defaultTitle : '%s', headTitleTemplate, getCb(vm, 'titleTemplateCallback')])
  }

  function beforeRouteUpdate(to, from, next) {
    resetHeadData(this)
    next()
  }

  function beforeRouteEnter(to, from, next) {
    next(vm => {
      resetHeadData(vm)
      vm.$headRouteComponent = true
      vm.hm = {
        currentData: {
          title: '',
          titleTemplate: '',
          meta: [],
          link: []
        },
        currentPath: false
      }

      setData(vm)
    })
  }

  function beforeRouteLeave(to, from, next) {
    resetHeadData(this)
    next()
  }

  Vue.prototype.$toggleHeadEdit = function() {
    const EditPages = require('dev/edit-pages')
    const store = this.$store
    const _this = this

    const toggleHeadManagement = function() {
      _this.$store.commit('EDIT_HEAD_MANAGEMENT', !_this.$store.state.editHeadManagment)
      const editCb = Vue[options.toggleEditCallback]
      if (typeof editCb === 'function') {
        editCb(_this, _this.$store.state.editHeadManagment)
      }
    }

    if (!store.hasModule('editPages')) {
      EditPages.default.store().then(moduleStore => {
        store.registerModule('editPages', moduleStore.default, { preserveState: store.state.editPages !== undefined })
        toggleHeadManagement()
      })
    } else {
      toggleHeadManagement()
    }
  }

  Vue.prototype.$resetCurrentHeadData = resetHeadData

  Vue.mixin({
    created: function() {
      this.hm = {
        currentData: {
          title: '',
          titleTemplate: '',
          meta: [],
          link: []
        },
        currentPath: false
      }
    },
    metaInfo: getMeta,
    beforeRouteUpdate: beforeRouteUpdate,
    beforeRouteEnter: beforeRouteEnter,
    beforeRouteLeave: beforeRouteLeave
  })
}

export default {
  install
}
